import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'
import { client } from '@Utils'
import { useStateValue } from '../../state'
import { ViewKeysLink } from './ViewKeysLink'
import { ltiOrgKeyManagement as endpoints } from '@URLS'

export const OrgTable = () => {
  const [currentState, dispatch] = useStateValue()
  useEffect(() => {
    const getAllOrgs = async () => {
      let resp = await client.get(endpoints.getOrgs())
      await dispatch({
        type: 'updateTable',
        tableData: resp.data.organizations,
      })
    }
    getAllOrgs()
  }, [])

  return (
    <Table striped bordered condensed hover>
      <thead>
        <tr>
          <th>Internal Name</th>
          <th>Name</th>
          <th>Created</th>
          <th>Domain</th>
          <th>Keys</th>
          <th>Details</th>
        </tr>
      </thead>
      <tbody>
        {currentState.tableData.map((org, i) => (
          <tr key={i}>
            <td>{org.internal_name}</td>
            <td>{org.name}</td>
            <td>{org.create_date}</td>
            <td>{org.instance_domain}</td>
            <td>
              <ViewKeysLink keyData={org.keyData} />
            </td>
            <td>
              <Link
                to={`/account/admin_lti_org_key_management/-/organizations/${org.id}`}
              >
                View Org
              </Link>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
